const benefits = [
  {
    icon: "ri-shield-check-fill",
    color: "#1E88E5",
    bg: "#EBF4FF",
    title: "Prevent Costly Property Damage",
    desc: "Blocked gutters are a leading cause of damp, subsidence, and fascia rot in UK homes. Regular gutter clearance in Northfleet and Gravesend protects your property's structure and avoids expensive repair bills down the line.",
  },
  {
    icon: "ri-water-flash-fill",
    color: "#0369A1",
    bg: "#E0F2FE",
    title: "Stop Overflows & Flooding",
    desc: "When gutters become clogged with leaves, moss, and debris, rainwater has nowhere to go — causing overflows that can flood driveways, damage foundations, and saturate brickwork. Our gutter clearance service keeps water flowing freely.",
  },
  {
    icon: "ri-microscope-fill",
    color: "#0F766E",
    bg: "#CCFBF1",
    title: "Remove Moss, Algae & Debris",
    desc: "Over time, gutters accumulate moss, algae, silt, and compacted leaves. Our professional vacuuming removes all organic matter, leaving your guttering system completely clear and flowing at full capacity.",
  },
  {
    icon: "ri-calendar-2-fill",
    color: "#065F46",
    bg: "#D1FAE5",
    title: "Extend the Life of Your Gutters",
    desc: "Neglected gutters deteriorate much faster. Weight from debris causes sagging, joints to fail, and fascias to rot. Scheduled gutter maintenance extends the lifespan of your guttering system, saving you money on replacement costs.",
  },
  {
    icon: "ri-home-smile-2-fill",
    color: "#7C3AED",
    bg: "#EDE9FE",
    title: "Improve Your Property's Kerb Appeal",
    desc: "Clean, properly functioning gutters contribute to the overall appearance of your property. Whether you're a homeowner in Northfleet or a business owner in Gravesend, well-maintained gutters make a great first impression.",
  },
];

export default function GutterBenefits() {
  return (
    <section className="py-24 bg-[#F8FAFE]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#1E88E5] font-heading font-semibold text-sm uppercase tracking-widest block mb-3">
            Why It Matters
          </span>
          <h2
            className="font-heading text-[#0F2040] leading-tight mb-5"
            style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 800 }}
          >
            The Benefits of Professional Gutter Clearance
          </h2>
          <p className="text-gray-600 font-body text-base leading-relaxed max-w-2xl mx-auto">
            Many property owners overlook their gutters until something goes wrong. Regular professional gutter clearance from Mighty Cleaning Services Ltd is one of the most cost-effective ways to protect your home or commercial property in <strong>Northfleet, Gravesend</strong>, and across Kent.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-white rounded-2xl p-7 border border-gray-100 hover:border-gray-200 transition-all group"
            >
              <div
                className="w-13 h-13 flex items-center justify-center rounded-xl mb-5 w-12 h-12"
                style={{ backgroundColor: benefit.bg }}
              >
                <i className={`${benefit.icon} text-xl`} style={{ color: benefit.color }}></i>
              </div>
              <h3 className="font-heading font-700 text-[#0F2040] text-base mb-3" style={{ fontWeight: 700 }}>
                {benefit.title}
              </h3>
              <p className="font-body text-sm text-gray-600 leading-relaxed">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-14 rounded-2xl bg-[#1E88E5] px-10 py-9 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading text-white text-xl mb-1" style={{ fontWeight: 700 }}>
              Ready to book your gutter clearance in Northfleet or Gravesend?
            </h3>
            <p className="text-blue-100 font-body text-sm">
              Get a fast, no-obligation quote — we respond within 24 hours.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href="#quote-form"
              className="flex items-center gap-2 bg-white text-[#1E88E5] font-heading font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap hover:bg-blue-50"
            >
              <i className="ri-file-list-3-line"></i>
              Get a Free Quote
            </a>
            <a
              href="tel:02084322244"
              className="flex items-center gap-2 border border-white/40 text-white font-heading font-semibold text-sm px-6 py-3 rounded-lg hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              0208 43 222 44
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
